import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "box-content d-flex flex-column position-absolute w-100"
};
var _hoisted_2 = {
  "class": "d-flex align-items-center justify-content-between mx-lg-3 mb-3 mt-n2 py-1"
};
var _hoisted_3 = {
  key: 0,
  "class": "d-flex align-items-center"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "ms-3"
};
var _hoisted_6 = {
  "class": "font-size-14 font-weight-semibold"
};
var _hoisted_7 = {
  key: 1,
  "class": "d-flex align-items-center flex-grow-1"
};
var _hoisted_8 = {
  key: 2,
  "class": "d-flex align-items-center"
};
var _hoisted_9 = {
  "class": "d-flex flex-column h-100"
};
var _hoisted_10 = {
  "class": "mt-auto mx-lg-3"
};
var _hoisted_11 = {
  key: 1,
  "class": "message-sent"
};
import { ref, onUpdated } from 'vue';
import { useUserStore } from '@dashboardApp/stores/UserStore';
import Compose from '@dashboardApp/components/inbox/Compose';
import ArchiveMessageButton from './ArchiveMessageButton';
import DatedMessagesInner from './DatedMessagesInner';
import ThrottleStatus from './ThrottleStatus';
import FlagButton from '@dashboardApp/components/supplier/FlagButton.vue';
import MessageLoader from '@dashboardApp/components/loader/MessageLoader.vue';
export default {
  __name: 'DatedMessages',
  props: {
    threadId: {
      type: [String, Number]
    },
    groupedMessages: {
      type: Object,
      "default": {}
    },
    hasThreadMessages: {
      type: Boolean,
      "default": false
    },
    from: {
      type: Object,
      "default": {}
    },
    isArchived: {
      type: Boolean,
      "default": false
    },
    withReply: {
      type: Boolean,
      "default": false
    },
    // Data is loading
    isLoading: {
      type: Boolean,
      "default": false
    },
    isInitiallyLoading: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var userStore = useUserStore();
    var messagesScrollEl = ref(null);
    var prevScrollHeight;
    onUpdated(function () {
      if (props.isInitiallyLoading || props.isLoading) {
        return;
      }
      if (prevScrollHeight) {
        // Remaion on previous and last row on scroll up
        messagesScrollEl.value.scrollTop = messagesScrollEl.value.scrollHeight - prevScrollHeight;
      } else {
        // Scroll down to the bottom of the messages
        messagesScrollEl.value.scrollTop = messagesScrollEl.value.scrollHeight;
      }
      prevScrollHeight = messagesScrollEl.value.scrollHeight;
    });
    __expose({
      messagesScrollEl: messagesScrollEl
    });
    return function (_ctx, _cache) {
      var _unref$user;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": _normalizeClass([{
          loader: __props.isInitiallyLoading
        }, "header-top border-bottom border-gray-blueish"])
      }, [_createElementVNode("div", _hoisted_2, [__props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.from.avatar,
        "class": "avatar rounded-circle",
        width: "75",
        height: "75"
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.from.name), 1)])])) : _createCommentVNode("", true), __props.isInitiallyLoading ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [_createElementVNode("span", {
        "class": "icon rounded-circle placeholder sh-background-gray-blueish"
      }, null, -1), _createElementVNode("div", {
        "class": "ms-3 flex-grow-1"
      }, [_createElementVNode("span", {
        "class": "placeholder col-6 placeholder-xs sh-background-gray-blueish rounded-pill"
      })], -1)]))) : _createCommentVNode("", true), __props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(ArchiveMessageButton), {
        id: __props.threadId,
        isArchived: __props.isArchived,
        archiveClass: "mx-2"
      }, {
        archiveImg: _withCtx(function () {
          return _cache[1] || (_cache[1] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_archive-lg.svg"
          }, null, -1)]);
        }),
        unarchiveImg: _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_unarchive-lg.svg"
          }, null, -1)]);
        }),
        _: 1
      }, 8, ["id", "isArchived"]), __props.from.supplier.id ? (_openBlock(), _createBlock(FlagButton, {
        key: 0,
        supplierId: __props.from.supplier.id,
        supplierWebsite: __props.from.supplier.website,
        btnClass: "text-decoration-none d-inline-block ms-2 hover-opacity"
      }, {
        "default": _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createElementVNode("img", {
            src: "/img/v5/db-ic_flag_lg.svg"
          }, null, -1)]);
        }, undefined, true),
        _: 1
      }, 8, ["supplierId", "supplierWebsite"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 2), _createElementVNode("div", {
        ref_key: "messagesScrollEl",
        ref: messagesScrollEl,
        "class": "flex-grow-1 scrollbox overflow-y-auto scroll-bottom"
      }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [__props.isLoading ? (_openBlock(), _createBlock(MessageLoader, {
        key: 0
      })) : _createCommentVNode("", true), __props.hasThreadMessages ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupedMessages, function (messages, date) {
        return _openBlock(), _createBlock(_unref(DatedMessagesInner), {
          messages: messages,
          date: date
        }, null, 8, ["messages", "date"]);
      }), 256)), _createVNode(_unref(ThrottleStatus), {
        status: (_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.throttleStatus
      }, null, 8, ["status"])])) : _createCommentVNode("", true)])])], 512), _createVNode(_unref(Compose), {
        from: __props.from,
        "show-form": __props.withReply
      }, null, 8, ["from", "show-form"])]);
    };
  }
};